import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../controllers/Auth";

function RequireAuth({ children }) {
    const location = useLocation();

    if (useAuth.isAuthenticated() !== true) {
        const destino = location.pathname + location.search;
        if (destino && destino.startsWith("/") && !destino.startsWith("//")) {
            sessionStorage.setItem("oauth_return_to", destino);
        }
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default RequireAuth;


